import SwitchCheckboxIcon from './SwitchCheckboxIcon';

export { Props } from './SwitchCheckboxIcon';
export default SwitchCheckboxIcon;
